"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataExportCleanUpProcessor", {
    enumerable: true,
    get: function() {
        return DataExportCleanUpProcessor;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _common = require("@nestjs/common");
const _moment = /*#__PURE__*/ _interop_require_default(require("moment"));
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let DataExportCleanUpProcessor = class DataExportCleanUpProcessor {
    async job(job) {
        this.debugLog(`Job started for ${job.id}`);
        const queue = new _pqueue.default({
            concurrency: 1
        });
        try {
            const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
            const cutoffDate = (0, _moment.default)().subtract(4, 'hours');
            // Convert cutoff date to YYYY-MM-DD format to match folder structure
            const cutoffDateFormatted = cutoffDate.format('YYYY-MM-DD');
            // The pattern will match all files in data-export folders that are older than the cutoff date
            const globPattern = `nc/uploads/data-export/**`;
            const fileStream = await storageAdapter.scanFiles(globPattern);
            // Track statistics for logging
            let scannedCount = 0;
            let deletedCount = 0;
            let errorCount = 0;
            return new Promise((resolve, reject)=>{
                fileStream.on('error', (error)=>{
                    this.debugLog(`Error scanning files: ${error.message}`);
                    reject(error);
                });
                fileStream.on('data', (filePath)=>{
                    scannedCount++;
                    // Add file processing task to the queue
                    queue.add(async ()=>{
                        try {
                            // Skip if not a data export file
                            if (!filePath || typeof filePath !== 'string' || !filePath.startsWith('nc/uploads/data-export')) {
                                return;
                            }
                            // Extract date from file path (format: nc/uploads/data-export/YYYY-MM-DD/HH/...)
                            const pathParts = filePath.split('/');
                            const dateIndex = pathParts.indexOf('data-export') + 1;
                            if (dateIndex >= pathParts.length || !pathParts[dateIndex]) {
                                return;
                            }
                            const folderDate = pathParts[dateIndex];
                            // Check if folder date is before cutoff date
                            if (folderDate && folderDate < cutoffDateFormatted) {
                                await storageAdapter.fileDelete(filePath);
                                deletedCount++;
                                this.debugLog(`Deleted old export file: ${filePath}`);
                            }
                        } catch (e) {
                            errorCount++;
                            this.debugLog(`Error processing file ${filePath}: ${e.message}`);
                        // Don't rethrow to prevent queue from stopping
                        }
                    }).catch((err)=>{
                        errorCount++;
                        this.debugLog(`Queue error processing file ${filePath}: ${err.message}`);
                    });
                });
                fileStream.on('end', async ()=>{
                    try {
                        // Wait for all queued tasks to complete
                        await queue.onIdle();
                        this.debugLog(`Data export cleanup completed: Scanned ${scannedCount} files, deleted ${deletedCount} files, encountered ${errorCount} errors`);
                        this.debugLog(`Job completed for ${job.id}`);
                        resolve(true);
                    } catch (err) {
                        this.debugLog(`Error waiting for queue to complete: ${err.message}`);
                        reject(err);
                    }
                });
            });
        } catch (e) {
            this.debugLog(`Job failed: ${e.message}`);
            throw e;
        }
    }
    constructor(){
        this.debugLog = (0, _debug.default)('nc:jobs:data-export-clean-up');
    }
};
DataExportCleanUpProcessor = _ts_decorate([
    (0, _common.Injectable)()
], DataExportCleanUpProcessor);
